import { KeyboardArrowDown } from 'emotion-icons/material';
import * as React from 'react';
import MegaMenu from './MegaMenu.js';

var RenderNavItems = function RenderNavItems(_ref) {
  var navData = _ref.navData,
    _ref$featuredContent = _ref.featuredContent,
    featuredContent = _ref$featuredContent === void 0 ? null : _ref$featuredContent,
    _ref$Link = _ref.Link,
    Link = _ref$Link === void 0 ? null : _ref$Link;
  var linkDeterminer = function linkDeterminer(item) {
    var link = (item === null || item === void 0 ? void 0 : item.link) || (item === null || item === void 0 ? void 0 : item.href);
    var hasSubnav = item.subnav && (Array.isArray(item.subnav) ? item.subnav.length > 0 : true);
    if (hasSubnav) {
      return /*#__PURE__*/React.createElement(Link, {
        to: link
      }, /*#__PURE__*/React.createElement("span", null, item.text), " ", /*#__PURE__*/React.createElement(KeyboardArrowDown, {
        size: 18
      }));
    }
    return link ? /*#__PURE__*/React.createElement(Link, {
      to: link
    }, /*#__PURE__*/React.createElement("span", null, item.text)) : /*#__PURE__*/React.createElement("span", null, item.text);
  };
  var megaMenuDeterminer = function megaMenuDeterminer(item) {
    // For payload: use MegaMenu if any subitem has megaLinks
    var isPayloadMegaMenu = (item === null || item === void 0 ? void 0 : item.subnav) && Array.isArray(item.subnav) && item.subnav.some(function (subitem) {
      return (subitem === null || subitem === void 0 ? void 0 : subitem.megaLinks) && subitem.megaLinks.length > 0;
    });
    // For Contentful: use MegaMenu if megaMenu flag is set
    if (item.megaMenu && item.subnav || isPayloadMegaMenu) {
      return /*#__PURE__*/React.createElement(MegaMenu, {
        data: item,
        featuredContent: featuredContent,
        Link: Link
      });
    }
    if (item.subnav) {
      return /*#__PURE__*/React.createElement("ul", {
        className: "subnav"
      }, item.subnav.map(function (subitem) {
        return /*#__PURE__*/React.createElement("li", {
          key: subitem.text
        }, /*#__PURE__*/React.createElement(Link, {
          to: (subitem === null || subitem === void 0 ? void 0 : subitem.href) || subitem.link
        }, subitem.text));
      }));
    }
    return null;
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, navData.map(function (item) {
    return /*#__PURE__*/React.createElement("span", {
      key: item.text,
      className: "primary-link"
    }, linkDeterminer(item), megaMenuDeterminer(item));
  }));
};
var RenderNavItems$1 = RenderNavItems;

export { RenderNavItems$1 as default };
//# sourceMappingURL=RenderNavItems.js.map
